import type { ComponentType } from 'react';
import { useI18nContext } from '@/i18n/i18n-react';
import type { Locales, TranslationFunctions } from '@/i18n/i18n-types';
import { HelpText } from './help-text';
import ActiveUsersEnMdx, {
  title as activeUsersEnTitle,
} from './content/analytics/users/metrics/active-users.en.mdx';
import ActiveUsersPtMdx, {
  title as activeUsersPtTitle,
} from './content/analytics/users/metrics/active-users.pt.mdx';
import ActiveUsersChartEnMdx, {
  title as activeUsersChartEnTitle,
} from './content/analytics/users/charts/active-users-chart.en.mdx';
import ActiveUsersChartPtMdx, {
  title as activeUsersChartPtTitle,
} from './content/analytics/users/charts/active-users-chart.pt.mdx';
import AverageConversionEnMdx, {
  title as averageConversionEnTitle,
} from './content/analytics/campaigns/metrics/average-conversion.en.mdx';
import AverageConversionPtMdx, {
  title as averageConversionPtTitle,
} from './content/analytics/campaigns/metrics/average-conversion.pt.mdx';
import AverageTicketEnMdx, {
  title as averageTicketEnTitle,
} from './content/analytics/sales/metrics/average-ticket.en.mdx';
import AverageTicketPtMdx, {
  title as averageTicketPtTitle,
} from './content/analytics/sales/metrics/average-ticket.pt.mdx';
import AverageTicketChartEnMdx, {
  title as averageTicketChartEnTitle,
} from './content/analytics/sales/charts/average-ticket-chart.en.mdx';
import AverageTicketChartPtMdx, {
  title as averageTicketChartPtTitle,
} from './content/analytics/sales/charts/average-ticket-chart.pt.mdx';
import CampaignAverageClicksEnMdx, {
  title as campaignAverageClicksEnTitle,
} from './content/analytics/campaigns/metrics/campaign-average-clicks.en.mdx';
import CampaignAverageClicksPtMdx, {
  title as campaignAverageClicksPtTitle,
} from './content/analytics/campaigns/metrics/campaign-average-clicks.pt.mdx';
import CampaignAverageCtrEnMdx, {
  title as campaignAverageCtrEnTitle,
} from './content/analytics/campaigns/metrics/campaign-average-ctr.en.mdx';
import CampaignAverageCtrPtMdx, {
  title as campaignAverageCtrPtTitle,
} from './content/analytics/campaigns/metrics/campaign-average-ctr.pt.mdx';
import CampaignTotalOrdersEnMdx, {
  title as campaignTotalOrdersEnTitle,
} from './content/analytics/campaigns/metrics/campaign-total-orders.en.mdx';
import CampaignTotalOrdersPtMdx, {
  title as campaignTotalOrdersPtTitle,
} from './content/analytics/campaigns/metrics/campaign-total-orders.pt.mdx';
import CampaignTotalRevenueEnMdx, {
  title as campaignTotalRevenueEnTitle,
} from './content/analytics/campaigns/metrics/campaign-total-revenue.en.mdx';
import CampaignTotalRevenuePtMdx, {
  title as campaignTotalRevenuePtTitle,
} from './content/analytics/campaigns/metrics/campaign-total-revenue.pt.mdx';
import CampaignOrdersCountChartEnMdx, {
  title as campaignOrdersCountChartEnTitle,
} from './content/analytics/campaigns/charts/campaign-orders-count-chart.en.mdx';
import CampaignOrdersCountChartPtMdx, {
  title as campaignOrdersCountChartPtTitle,
} from './content/analytics/campaigns/charts/campaign-orders-count-chart.pt.mdx';
import CampaignOrdersRevenueChartEnMdx, {
  title as campaignOrdersRevenueChartEnTitle,
} from './content/analytics/campaigns/charts/campaign-orders-revenue-chart.en.mdx';
import CampaignOrdersRevenueChartPtMdx, {
  title as campaignOrdersRevenueChartPtTitle,
} from './content/analytics/campaigns/charts/campaign-orders-revenue-chart.pt.mdx';
import DownloadsEnMdx, {
  title as downloadsEnTitle,
} from './content/analytics/users/metrics/downloads.en.mdx';
import DownloadsPtMdx, {
  title as downloadsPtTitle,
} from './content/analytics/users/metrics/downloads.pt.mdx';
import DownloadsChartEnMdx, {
  title as downloadsChartEnTitle,
} from './content/analytics/users/charts/downloads-chart.en.mdx';
import DownloadsChartPtMdx, {
  title as downloadsChartPtTitle,
} from './content/analytics/users/charts/downloads-chart.pt.mdx';
import CumulativeDownloadsChartEnMdx, {
  title as cumulativeDownloadsChartEnTitle,
} from './content/analytics/users/charts/cumulative-downloads-chart.en.mdx';
import CumulativeDownloadsChartPtMdx, {
  title as cumulativeDownloadsChartPtTitle,
} from './content/analytics/users/charts/cumulative-downloads-chart.pt.mdx';
import PostDownloadConversionChartEnMdx, {
  title as postDownloadConversionChartEnTitle,
} from './content/analytics/users/charts/post-download-conversion-chart.en.mdx';
import PostDownloadConversionChartPtMdx, {
  title as postDownloadConversionChartPtTitle,
} from './content/analytics/users/charts/post-download-conversion-chart.pt.mdx';
import PostDownloadConversionEnMdx, {
  title as postDownloadConversionEnTitle,
} from './content/analytics/users/metrics/post-download-conversion.en.mdx';
import PostDownloadConversionPtMdx, {
  title as postDownloadConversionPtTitle,
} from './content/analytics/users/metrics/post-download-conversion.pt.mdx';
import ConvertedDownloadsEnMdx, {
  title as convertedDownloadsEnTitle,
} from './content/analytics/users/metrics/converted-downloads.en.mdx';
import ConvertedDownloadsPtMdx, {
  title as convertedDownloadsPtTitle,
} from './content/analytics/users/metrics/converted-downloads.pt.mdx';
import UsersWithEnabledNotificationsEnMdx, {
  title as usersWithEnabledNotificationsEnTitle,
} from './content/analytics/users/metrics/users-with-enabled-notifications.en.mdx';
import UsersWithEnabledNotificationsPtMdx, {
  title as usersWithEnabledNotificationsPtTitle,
} from './content/analytics/users/metrics/users-with-enabled-notifications.pt.mdx';
import OrdersCompositionEnMdx, {
  title as ordersCompositionEnTitle,
} from './content/analytics/sales/metrics/ordersComposition.en.mdx';
import OrdersCompositionPtMdx, {
  title as ordersCompositionPtTitle,
} from './content/analytics/sales/metrics/ordersComposition.pt.mdx';
import OrdersCompletionEnMdx, {
  title as ordersCompletionEnTitle,
} from './content/analytics/sales/metrics/ordersCompletion.en.mdx';
import OrdersCompletionPtMdx, {
  title as ordersCompletionPtTitle,
} from './content/analytics/sales/metrics/ordersCompletion.pt.mdx';
import RepurchaseRateChartEnMdx, {
  title as repurchaseRateChartEnTitle,
} from './content/analytics/sales/charts/repurchase-rate-chart.en.mdx';
import RepurchaseRateChartPtMdx, {
  title as repurchaseRateChartPtTitle,
} from './content/analytics/sales/charts/repurchase-rate-chart.pt.mdx';
import RevenueEnMdx, {
  title as revenueEnTitle,
} from './content/analytics/sales/metrics/revenue.en.mdx';
import RevenuePtMdx, {
  title as revenuePtTitle,
} from './content/analytics/sales/metrics/revenue.pt.mdx';
import SalesChartEnMdx, {
  title as salesChartEnTitle,
} from './content/analytics/sales/charts/sales-chart.en.mdx';
import SalesChartPtMdx, {
  title as salesChartPtTitle,
} from './content/analytics/sales/charts/sales-chart.pt.mdx';
import TotalDownloadsEnMdx, {
  title as totalDownloadsEnTitle,
} from './content/analytics/users/metrics/total-downloads.en.mdx';
import TotalDownloadsPtMdx, {
  title as totalDownloadsPtTitle,
} from './content/analytics/users/metrics/total-downloads.pt.mdx';
import TotalSalesEnMdx, {
  title as totalSalesEnTitle,
} from './content/analytics/sales/metrics/total-sales.en.mdx';
import TotalSalesPtMdx, {
  title as totalSalesPtTitle,
} from './content/analytics/sales/metrics/total-sales.pt.mdx';

export type HelpRegistryEntry = {
  getTitle: (LL: TranslationFunctions, locale: Locales) => string;
  getContent: (locale: Locales) => ComponentType;
};

type LocalizedMdxModule = {
  default: ComponentType;
  title: string;
};

function createPlainHelp(
  getBody: (LL: TranslationFunctions) => string
): ComponentType {
  function Content() {
    const { LL } = useI18nContext();
    return <HelpText text={getBody(LL)} />;
  }
  Content.displayName = 'PlainHelpContent';
  return Content;
}

function entry(
  getTitle: (LL: TranslationFunctions) => string,
  getBody: (LL: TranslationFunctions) => string
): HelpRegistryEntry {
  const Content = createPlainHelp(getBody);
  return {
    getTitle: (LL) => getTitle(LL),
    getContent: () => Content,
  };
}

function entryFromLocalizedMdx(
  modulesByLocale: Record<Locales, LocalizedMdxModule>
): HelpRegistryEntry {
  return {
    getTitle: (_LL, locale) => modulesByLocale[locale].title,
    getContent: (locale) => modulesByLocale[locale].default,
  };
}

function localizedEntry(
  moduleEn: LocalizedMdxModule,
  modulePt: LocalizedMdxModule
): HelpRegistryEntry {
  return entryFromLocalizedMdx({
    en: moduleEn,
    pt: modulePt,
  });
}

/** Keys must match `helpKey` props on the analytics page. */
export const helpContentRegistry: Record<string, HelpRegistryEntry> = {
  overviewSales: entry(
    (LL) => LL.metricsPage.help.overviewSales.title(),
    (LL) => LL.metricsPage.help.overviewSales.body()
  ),
  overviewCampaigns: entry(
    (LL) => LL.metricsPage.help.overviewCampaigns.title(),
    (LL) => LL.metricsPage.help.overviewCampaigns.body()
  ),
  overviewUsers: entry(
    (LL) => LL.metricsPage.help.overviewUsers.title(),
    (LL) => LL.metricsPage.help.overviewUsers.body()
  ),
  overviewOrders: entry(
    (LL) => LL.metricsPage.help.overviewOrders.title(),
    (LL) => LL.metricsPage.help.overviewOrders.body()
  ),
  appShare: entry(
    (LL) => LL.metricsPage.help.appShare.title(),
    (LL) => LL.metricsPage.help.appShare.body()
  ),
  pushFunnel: entry(
    (LL) => LL.metricsPage.help.pushFunnel.title(),
    (LL) => LL.metricsPage.help.pushFunnel.body()
  ),
  sessionsChart: entry(
    (LL) => LL.metricsPage.help.sessions.title(),
    (LL) => LL.metricsPage.help.sessions.body()
  ),
  installedVersions: entry(
    (LL) => LL.metricsPage.help.installedVersions.title(),
    (LL) => LL.metricsPage.help.installedVersions.body()
  ),
  roi: entry(
    (LL) => LL.metricsPage.help.roi.title(),
    (LL) => LL.metricsPage.help.roi.body()
  ),
  totalSales: localizedEntry(
    {
      default: TotalSalesEnMdx,
      title: totalSalesEnTitle,
    },
    {
      default: TotalSalesPtMdx,
      title: totalSalesPtTitle,
    }
  ),
  revenue: localizedEntry(
    {
      default: RevenueEnMdx,
      title: revenueEnTitle,
    },
    {
      default: RevenuePtMdx,
      title: revenuePtTitle,
    }
  ),
  averageTicket: localizedEntry(
    {
      default: AverageTicketEnMdx,
      title: averageTicketEnTitle,
    },
    {
      default: AverageTicketPtMdx,
      title: averageTicketPtTitle,
    }
  ),
  ordersComposition: localizedEntry(
    {
      default: OrdersCompositionEnMdx,
      title: ordersCompositionEnTitle,
    },
    {
      default: OrdersCompositionPtMdx,
      title: ordersCompositionPtTitle,
    }
  ),
  ordersCompletion: localizedEntry(
    {
      default: OrdersCompletionEnMdx,
      title: ordersCompletionEnTitle,
    },
    {
      default: OrdersCompletionPtMdx,
      title: ordersCompletionPtTitle,
    }
  ),
  appConversion: entry(
    (LL) => LL.metricsPage.help.appConversion.title(),
    (LL) => LL.metricsPage.help.appConversion.body()
  ),
  downloads: localizedEntry(
    {
      default: DownloadsEnMdx,
      title: downloadsEnTitle,
    },
    {
      default: DownloadsPtMdx,
      title: downloadsPtTitle,
    }
  ),
  totalDownloads: localizedEntry(
    {
      default: TotalDownloadsEnMdx,
      title: totalDownloadsEnTitle,
    },
    {
      default: TotalDownloadsPtMdx,
      title: totalDownloadsPtTitle,
    }
  ),
  activeUsers: localizedEntry(
    {
      default: ActiveUsersEnMdx,
      title: activeUsersEnTitle,
    },
    {
      default: ActiveUsersPtMdx,
      title: activeUsersPtTitle,
    }
  ),
  postDownloadConversion: localizedEntry(
    {
      default: PostDownloadConversionEnMdx,
      title: postDownloadConversionEnTitle,
    },
    {
      default: PostDownloadConversionPtMdx,
      title: postDownloadConversionPtTitle,
    }
  ),
  convertedDownloads: localizedEntry(
    {
      default: ConvertedDownloadsEnMdx,
      title: convertedDownloadsEnTitle,
    },
    {
      default: ConvertedDownloadsPtMdx,
      title: convertedDownloadsPtTitle,
    }
  ),
  usersWithEnabledNotifications: localizedEntry(
    {
      default: UsersWithEnabledNotificationsEnMdx,
      title: usersWithEnabledNotificationsEnTitle,
    },
    {
      default: UsersWithEnabledNotificationsPtMdx,
      title: usersWithEnabledNotificationsPtTitle,
    }
  ),
  notificationConversion: localizedEntry(
    {
      default: AverageConversionEnMdx,
      title: averageConversionEnTitle,
    },
    {
      default: AverageConversionPtMdx,
      title: averageConversionPtTitle,
    }
  ),
  campaignTotalOrders: localizedEntry(
    {
      default: CampaignTotalOrdersEnMdx,
      title: campaignTotalOrdersEnTitle,
    },
    {
      default: CampaignTotalOrdersPtMdx,
      title: campaignTotalOrdersPtTitle,
    }
  ),
  campaignTotalRevenue: localizedEntry(
    {
      default: CampaignTotalRevenueEnMdx,
      title: campaignTotalRevenueEnTitle,
    },
    {
      default: CampaignTotalRevenuePtMdx,
      title: campaignTotalRevenuePtTitle,
    }
  ),
  campaignAverageCtr: localizedEntry(
    {
      default: CampaignAverageCtrEnMdx,
      title: campaignAverageCtrEnTitle,
    },
    {
      default: CampaignAverageCtrPtMdx,
      title: campaignAverageCtrPtTitle,
    }
  ),
  campaignAverageClicks: localizedEntry(
    {
      default: CampaignAverageClicksEnMdx,
      title: campaignAverageClicksEnTitle,
    },
    {
      default: CampaignAverageClicksPtMdx,
      title: campaignAverageClicksPtTitle,
    }
  ),
  averageCampaignRevenue: entry(
    (LL) => LL.metricsPage.help.averageCampaignRevenue.title(),
    (LL) => LL.metricsPage.help.averageCampaignRevenue.body()
  ),
  averageCampaignImpact: entry(
    (LL) => LL.metricsPage.help.averageCampaignImpact.title(),
    (LL) => LL.metricsPage.help.averageCampaignImpact.body()
  ),
  salesChart: localizedEntry(
    {
      default: SalesChartEnMdx,
      title: salesChartEnTitle,
    },
    {
      default: SalesChartPtMdx,
      title: salesChartPtTitle,
    }
  ),
  averageTicketChart: localizedEntry(
    {
      default: AverageTicketChartEnMdx,
      title: averageTicketChartEnTitle,
    },
    {
      default: AverageTicketChartPtMdx,
      title: averageTicketChartPtTitle,
    }
  ),
  repurchaseRateChart: localizedEntry(
    {
      default: RepurchaseRateChartEnMdx,
      title: repurchaseRateChartEnTitle,
    },
    {
      default: RepurchaseRateChartPtMdx,
      title: repurchaseRateChartPtTitle,
    }
  ),
  postDownloadConversionChart: localizedEntry(
    {
      default: PostDownloadConversionChartEnMdx,
      title: postDownloadConversionChartEnTitle,
    },
    {
      default: PostDownloadConversionChartPtMdx,
      title: postDownloadConversionChartPtTitle,
    }
  ),
  campaignOrdersCountChart: localizedEntry(
    {
      default: CampaignOrdersCountChartEnMdx,
      title: campaignOrdersCountChartEnTitle,
    },
    {
      default: CampaignOrdersCountChartPtMdx,
      title: campaignOrdersCountChartPtTitle,
    }
  ),
  campaignOrdersRevenueChart: localizedEntry(
    {
      default: CampaignOrdersRevenueChartEnMdx,
      title: campaignOrdersRevenueChartEnTitle,
    },
    {
      default: CampaignOrdersRevenueChartPtMdx,
      title: campaignOrdersRevenueChartPtTitle,
    }
  ),
  appConversionChart: entry(
    (LL) => LL.metricsPage.help.appConversionChart.title(),
    (LL) => LL.metricsPage.help.appConversionChart.body()
  ),
  downloadsChart: localizedEntry(
    {
      default: DownloadsChartEnMdx,
      title: downloadsChartEnTitle,
    },
    {
      default: DownloadsChartPtMdx,
      title: downloadsChartPtTitle,
    }
  ),
  downloadsCumulativeChart: localizedEntry(
    {
      default: CumulativeDownloadsChartEnMdx,
      title: cumulativeDownloadsChartEnTitle,
    },
    {
      default: CumulativeDownloadsChartPtMdx,
      title: cumulativeDownloadsChartPtTitle,
    }
  ),
  activeUsersChart: localizedEntry(
    {
      default: ActiveUsersChartEnMdx,
      title: activeUsersChartEnTitle,
    },
    {
      default: ActiveUsersChartPtMdx,
      title: activeUsersChartPtTitle,
    }
  ),
  roiBreakdown: entry(
    (LL) => LL.metricsPage.help.roiBreakdown.title(),
    (LL) => LL.metricsPage.help.roiBreakdown.body()
  ),
  rfmMatrix: entry(
    (LL) => LL.metricsPage.help.rfmMatrix.title(),
    (LL) => LL.metricsPage.help.rfmMatrix.body()
  ),
};
